import { wavespurple } from '@mentimeter/sfinx-themes';

export const WavesPurpleBackground = wavespurple.background;
